module.exports = __webpack_public_path__ + "static/media/huiyuan1.4b9fe436.png";